import { useEffect } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import HeaderFooterLayout from '../components/layouts/HeaderFooterLayout';
import { generalPrivacySections } from '../content/informativaGeneraleV31';
import styles from './InformativaGenerale.module.css';

const InformativaGenerale = () => {
    useEffect(() => {
        const id = window.location.hash.replace('#', '');
        if (!id) return undefined;

        const frame = window.requestAnimationFrame(() => {
            const element = document.getElementById(id);
            if (!element) return;

            const position = element.getBoundingClientRect();
            const offset = parseFloat(getComputedStyle(element).scrollMarginTop) || 24;
            window.scrollTo({
                top: window.scrollY + position.top - offset,
                behavior: 'smooth',
            });
            element.classList.add(styles.highlight);
            window.setTimeout(() => element.classList.remove(styles.highlight), 3000);
        });

        return () => window.cancelAnimationFrame(frame);
    }, []);

    return (
        <HeaderFooterLayout contentStyle={{ backgroundColor: 'var(--background-secondary-color)' }}>
            <div className={styles.container}>
                <div className={styles.section}>
                    <div className={styles.sectionInner}>
                        <Breadcrumb items={[
                            { label: 'Home', to: '/' },
                            { label: 'Privacy Policy', to: '/privacy-policy' },
                            { label: 'Informativa generale' },
                        ]} />

                        <header className={styles.header}>
                            <span className={styles.eyebrow}>Starting Finance S.r.l.</span>
                            <h1>Informativa generale sul trattamento dei dati personali</h1>
                            <p>(ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 - GDPR)</p>
                            <p className={styles.version}>Versione 3.1 · Data ultimo aggiornamento: 22 ottobre 2026</p>
                            <p className={styles.replacementNotice}>
                                La presente informativa sostituisce ogni versione precedente e si applica ai trattamenti effettuati a partire dal 22 ottobre 2026, salvo quanto previsto al paragrafo 11 per le modifiche rilevanti.
                            </p>
                        </header>

                        <div className={styles.layout}>
                            <details className={styles.index} open>
                                <summary>In questa pagina</summary>
                                <nav aria-label="Indice dell’informativa generale">
                                    {generalPrivacySections.map((section) => (
                                        <a key={section.id} href={`#${section.id}`}>{section.title}</a>
                                    ))}
                                </nav>
                            </details>

                            <article className={styles.document}>
                                {generalPrivacySections.map((section) => (
                                    <section className={styles.documentCard} id={section.id} key={section.id}>
                                        <h2 className={styles.title}>{section.title}</h2>
                                        <div dangerouslySetInnerHTML={{ __html: section.html }} />
                                    </section>
                                ))}
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </HeaderFooterLayout>
    );
};

export default InformativaGenerale;
